var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserManualIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_149_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05456 7.39093V7.36365H6.02729H3.07273C1.92994 7.36365 1 8.2936 1 9.43638V11.9364V11.9636H1.02727H1.48182H1.50909V11.9364V9.43638C1.50909 8.57413 2.21052 7.87273 3.07273 7.87273H6.02729H6.05456V7.84545V7.39093ZM6.90907 11.9364V11.9636H6.93635H11.9364H11.9636V11.9364V6.93635C11.9636 6.41996 11.5437 6.00002 11.0273 6.00002H7.84545C7.32902 6.00002 6.90907 6.41996 6.90907 6.93635V11.9364ZM8.29998 7.36365H8.27271V7.39093V7.84545V7.87273H8.29998H10.5727H10.6V7.84545V7.39093V7.36365H10.5727H8.29998ZM8.29998 8.72865H8.27271V8.75593V9.21046V9.23773H8.29998H10.5727H10.6V9.21046V8.75593V8.72865H10.5727H8.29998ZM8.29998 10.0909H8.27271V10.1182V10.5727V10.6H8.29998H10.5727H10.6V10.5727V10.1182V10.0909H10.5727H8.29998ZM5.11818 6.50909C6.63733 6.50909 7.87273 5.2737 7.87273 3.75455C7.87273 2.23539 6.63733 1 5.11818 1C3.59903 1 2.36364 2.23539 2.36364 3.75455C2.36364 5.2737 3.59903 6.50909 5.11818 6.50909ZM5.11818 1.50909C6.35631 1.50909 7.36365 2.51642 7.36365 3.75455C7.36365 4.99267 6.35631 6.00002 5.11818 6.00002C3.88006 6.00002 2.87273 4.99267 2.87273 3.75455C2.87273 2.51642 3.88006 1.50909 5.11818 1.50909ZM11.4546 11.4546H7.4182V6.93635C7.4182 6.70093 7.6096 6.50909 7.84545 6.50909H11.0273C11.2631 6.50909 11.4546 6.70093 11.4546 6.93635V11.4546Z",
    fill: "#E66100",
    stroke: "#E66100",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_149_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManualIcon);
export default __webpack_public_path__ + "static/media/User-Manual_Icon.5933424d32414671b0f11da7a7388abe.svg";
export { ForwardRef as ReactComponent };